import { useQuery, useQueryClient, useMutation } from '@tanstack/react-query';
import {
  createQasRequiredFields,
  editQasRequiredFields,
  deleteQasRequiredFields,
  getQasRequiredFields,
  getAllProductFields,
  getAllTargetMembers,
} from 'services/qas-require-field/';
import { addMoreDollarGeneralFields } from './utils';
import { dollarGeneralAllFields } from './dollarGeneralFields';

export const QUERY_KEY_QAS_REQUIRE_FIELD = {
  GET_ALL_TARGET_MEMBER: 'qas/get-all-target-members',
  GET_ALL_PRODUCT_FIELDS: 'qas/get-all-product-fields',
  GET_QAS_REQUIRED_FIELDS: 'qas/get-qas-required-fields',
};

export const useCreateQasRequiredFields = () =>
  useMutation({ mutationFn: createQasRequiredFields });

export const useEditQasRequiredFields = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: editQasRequiredFields,
    onSuccess: (response) => {
      if (response?.isSuccess)
        queryClient.invalidateQueries({
          queryKey: [
            QUERY_KEY_QAS_REQUIRE_FIELD.GET_QAS_REQUIRED_FIELDS,
            response?.data?.id,
          ],
        });
    },
  });
};

export const useDeleteQasRequiredFields = () =>
  useMutation({ mutationFn: deleteQasRequiredFields });

export const useGetQasRequiredFields = (id) =>
  useQuery({
    queryKey: [QUERY_KEY_QAS_REQUIRE_FIELD.GET_QAS_REQUIRED_FIELDS, id],
    queryFn: async () => {
      const reponse = await getQasRequiredFields({ id });
      return reponse?.data;
    },
    enabled: !!id,
  });

export const useGetAllTargetMembers = (searchText) =>
  useQuery({
    queryKey: [QUERY_KEY_QAS_REQUIRE_FIELD.GET_ALL_TARGET_MEMBER, searchText],
    queryFn: async () => {
      const reponse = await getAllTargetMembers({ searchText });
      return reponse?.data;
    },
    enabled: !!searchText,
  });

export const useGetAllProductFields = (option) => {
  const { data, ...rest } = useQuery({
    queryKey: [QUERY_KEY_QAS_REQUIRE_FIELD.GET_ALL_PRODUCT_FIELDS],
    queryFn: async () => {
      const response = await getAllProductFields();

      return response?.data?.groups || [];
    },
    ...option,
  });

  return {
    // data: addMoreDollarGeneralFields(
    //   data ?? []
    // ) /* back to old code when PR of Viet is merged */,
    data: dollarGeneralAllFields,
    ...rest,
  };
};
